import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Link2 } from "lucide-react";

export default function Eslesmeler() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/matches").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const act = async (m, a) => {
    try { await api.post(`/matches/${m.id}/${a}`); toast.success(a === "approve" ? "EŞLEŞTİRİLDİ — ALIM TEKRAR YÜKLENMEZ" : "REDDEDİLDİ"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); load(); }
  };
  return (
    <div data-testid="matches-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><Link2 className="h-6 w-6 text-sky-400" /> BEKLEYEN EŞLEŞMELER <span data-testid="matches-count" className="text-base text-amber-300">({rows.length})</span></h1></BarTitle>
      <p className="text-xs text-slate-400">KESİLEN KARGO İLE AYNI MÜŞTERİ + VARIŞ İLİ + ADET OLAN ALIM. ONAYLARSANIZ KARGO O ALIMIN TIR'INA BAĞLANIR, ALIM İKİNCİ KEZ YÜKLENMEZ.</p>
      <div className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-[12px] text-slate-200">
          <thead><tr className="border-b border-slate-700 text-left text-slate-400">{["KARGO", "TAKİP NO", "ALIM", "MÜŞTERİ", "VARIŞ İLİ", "ADET", "TIR", "ALIM TARİHİ", ""].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="px-2 py-6 text-center text-slate-500">BEKLEYEN EŞLEŞME YOK</td></tr>}
            {rows.map((m) => (
              <tr key={m.id} data-testid={`match-${m.id}`} className="border-b border-slate-800">
                <td className="px-2 py-1">#{m.cargo_id}</td><td className="px-2 py-1 font-mono">{m.takip_no}</td><td className="px-2 py-1">#{m.pickup_id}</td>
                <td className="px-2 py-1 font-semibold">{m.firma}</td><td className="px-2 py-1">{m.il}</td><td className="px-2 py-1">{m.adet}</td>
                <td className="px-2 py-1">{m.tir_id || "—"}</td><td className="px-2 py-1">{m.alim_tarih}</td>
                <td className="flex gap-1 px-2 py-1">
                  <Button data-testid={`match-approve-${m.id}`} size="sm" onClick={() => act(m, "approve")} className="h-7 bg-emerald-600 text-white hover:bg-emerald-700">ONAYLA</Button>
                  <Button data-testid={`match-reject-${m.id}`} size="sm" variant="outline" onClick={() => act(m, "reject")} className="h-7 border-slate-700 bg-slate-800 text-slate-200">EŞLEŞTİRME</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
